import { HeaderCrawler } from "./HeaderCrawler";
import { HeaderSkyline } from "./HeaderSkyline";
import { BatSilhouette, WitchSilhouette } from "./Silhouettes";

/**
 * Static skyline and witch for the mobile top bar, plus the once-per-load crawler (portaled, hidden under reduced motion).
 * Rendered between the title and the right-side icons: the witch's zero-width anchor sits exactly where the
 * title's free space ends, so she lands in the gap however many icons the page shows, without moving anything.
 */
export const MobileHeaderDecor = () => (
  <>
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
      <HeaderSkyline compact className="h-3" />
    </div>
    <div aria-hidden="true" className="pointer-events-none relative -z-10 w-0 shrink-0 self-stretch">
      <div className="absolute top-1.5 right-1 h-6 w-15">
        <BatSilhouette width={8} height={4} className="absolute top-4 left-0" />
        <WitchSilhouette width={34} height={22} className="absolute top-0.5 left-4" />
        <BatSilhouette width={10} height={5} className="absolute top-0 left-12.75" />
      </div>
    </div>
    <HeaderCrawler mobile />
  </>
);
